var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c(
        "article",
        { staticClass: "tile is-child box" },
        [
          _c(
            "bulma-table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              attrs: {
                columns: _vm.columns,
                "page-index": _vm.filter.pageIndex,
                "page-size": _vm.filter.pageSize,
                "total-rows": _vm.totalRows,
                "is-loading": _vm.isTableLoading,
                "sort-column": _vm.filter.sortColumn,
                "sort-order": _vm.filter.sortOrder,
              },
              on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
            },
            [
              _vm._l(_vm.pagedItems, function (item, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                    class: { "is-selected": _vm.selectedRow === index },
                  },
                  [
                    _c("td", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.itemNo)),
                    ]),
                    _c("td", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.itemDesc)),
                    ]),
                    _c("td", { staticClass: "has-vertical-middle" }, [
                      _vm._v(_vm._s(item.itemType)),
                    ]),
                    _c("td", { staticClass: "is-comment-input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.comments[
                                index +
                                  (_vm.filter.pageIndex - 1) *
                                    _vm.filter.pageSize
                              ].comment,
                            expression:
                              "comments[index + ((filter.pageIndex - 1) * filter.pageSize)].comment",
                          },
                        ],
                        staticClass: "input",
                        domProps: {
                          value:
                            _vm.comments[
                              index +
                                (_vm.filter.pageIndex - 1) * _vm.filter.pageSize
                            ].comment,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.comments[
                                index +
                                  (_vm.filter.pageIndex - 1) *
                                    _vm.filter.pageSize
                              ],
                              "comment",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]
                )
              }),
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("span", { attrs: { icon: "icon is-large" } }, [
                        _c("i", {
                          staticClass: "mdi mdi-48px mdi-emoticon-sad",
                        }),
                      ]),
                      _c("p", [_vm._v("Nothing")]),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }